// Generated by CoffeeScript 2.7.0
var TagGroupListItem;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import EditTagGroupModal from 'trunks/vue/admin/compositions/tags_groups/tag_group_modal/edit_tag_group_modal.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

export default TagGroupListItem = {
  components: {
    Popover: Popover
  },
  props: {
    group: {
      type: Object,
      default: function() {
        return {};
      }
    },
    selectedTagsGroupId: {
      type: [String, Number],
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    return {
      showPopover: false
    };
  },
  template: `<div class="list-item node-wrapper justify-between"
     :class="{ selected: selected }"
     @click="groupChange">
  <div class="name">
    <span>{{group.name}}</span>
  </div>
  <Popover position='bottom right'
           size="small"
           @beforeOpen="popoverBeforeOpen"
           @beforeClose="popoverBeforeClose"
           ref="popoverRef">
    <template slot="trigger">
      <div :class='nodeClass' @click.stop="togglePopover">
        <i class="slp-ellipsis-circle-o"></i>
      </div>
    </template>
    <div class="list" slot="content">
      <div class="list-item" @click.stop="openEditTagsGroupModal">
        <i class="slp-pencil"></i>
        <span class="ml-2">编辑标签分组</span>
      </div>
      <div class="list-item" @click.stop="deleteTagsGroup">
        <i class="slp-trash"></i>
        <span class="ml-2">删除标签分组</span>
      </div>
    </div>
  </Popover>
</div>`,
  computed: {
    selected: function() {
      return parseInt(this.selectedTagsGroupId) === this.group.id;
    },
    nodeClass: function() {
      return {
        "node-hover": !this.showPopover,
        "node-show": this.showPopover
      };
    }
  },
  methods: {
    groupChange: function() {
      return this.$emit('selectedTagsGroupChange', this.group);
    },
    popoverBeforeOpen: function() {
      return this.showPopover = true;
    },
    popoverBeforeClose: function() {
      return this.showPopover = false;
    },
    openEditTagsGroupModal: function() {
      this.togglePopover();
      return new EditTagGroupModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-tag-group-modal'),
        propsData: {
          title: '编辑标签分组',
          initialTagGroupName: this.group.name,
          callback: (tagGroupName) => {
            return this.editTagGroupFunc(tagGroupName);
          }
        }
      });
    },
    editTagGroupFunc: function(tagGroupName) {
      return Skylark.Libs.Ajax.patch(`/admin/tag_groups/${this.group.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          tag_group: {
            name: tagGroupName
          }
        },
        success: (data) => {
          Skylark.Bridge.newAlertify('编辑标签分组成功', {
            type: 'success'
          });
          return this.group.name = tagGroupName;
        },
        error: function() {
          return Skylark.Bridge.newAlertify('编辑标签分组失败', {
            type: 'error'
          });
        }
      });
    },
    deleteTagsGroup: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '是否删除此标签分组',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger',
        message: `确认删除后，${this.group.name}分组下的所有标签将一同删除`
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`/admin/tag_groups/${this.group.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            Skylark.Bridge.newAlertify('删除标签分组成功', {
              type: 'success'
            });
            return this.$emit('deletedTagGroup', this.group);
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除标签分组失败', {
              type: 'error'
            });
          }
        });
      });
    },
    togglePopover: function(event) {
      return this.$refs.popoverRef.togglePopover();
    }
  }
};
